import { COMMON_FUNCTION_NAME, FunctionResult } from "@nova/common-interfaces";
import { CommonService } from "./common.service.mjs";
import { Injectable } from "@angular/core";
import { Functions } from "@angular/fire/functions";

@Injectable({ providedIn: "root" })
export abstract class CommonBulkService<T, K> extends CommonService<T, K> {
  // #region Properties (1)

  public abstract insertBulkFunctionName: COMMON_FUNCTION_NAME;

  // #endregion Properties (1)

  // #region Constructors (1)

  constructor(functions: Functions) {
    super(functions);
  }

  // #endregion Constructors (1)

  // #region Public Methods (1)

  /**
   * Insert new objects of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T[] } obj
   * @param { boolean} refresh
   * @return { Promise<T[]> }
   */
  public async insertBulk(
    obj: T[],
    refresh: boolean = false
  ): Promise<FunctionResult<T[]>> {
    this.isLoading(true);
    /*
    await this.utility.functions.httpsCallable(this.insertBulkFunctionName())({payload: obj})
      .then((result: FunctionResult<T[]>) => {
        if (refresh)
        {
          this.getAll();
        }
        return Promise.resolve(result.data);
      })
      .catch((error: any) => {
        return Promise.reject(error);
        // Handle error, display user-friendly message, etc.
      })
      .finally(() => {
        this.isLoading(false);
      });
      */

    throw new Error("Should not have gotten here");
  }

  // #endregion Public Methods (1)
}
